import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseProtoDto } from '../../../shared/modules/base/dtos/base-proto.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { ProtoContactDto } from '../../contacts/dtos/proto-contact.dto';
import { ProtoDriverDto } from '../../drivers/dtos/proto-driver.dto';
import { AccountStatusEnum } from '../enums/account-status.enum';
import { AccountTypeEnum } from '../enums/account-type.enum';

/**
 * The account a caller reads back after create, get, or update.
 */
@CaslSubject(AppSubjectEnum.ACCOUNT)
export class AccountRecordDto extends BaseProtoDto {
  handle?: string | null;
  authProviderUserId?: string | null;
  color?: string;
  tenantOrgId?: string;
  email!: string;
  type!: AccountTypeEnum;
  contact!: ProtoContactDto;
  driver?: ProtoDriverDto;
  status!: AccountStatusEnum;
  notes?: string;
  files?: FileDto[];
}
